import { Box, CircularProgress, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { FontStyle, Panels, Slug, navPaddingTop, userStr } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import MessagesSidebar from "../components/ChatComponents/MessagesSidebar";
import ChatPanel from "../components/ChatComponents/ChatPanel";
import * as apiService from "../service/ApiService";
import {
  UrlParam,
  isLoggedIn,
  recruiterIdFromUrl,
  recruiterIdToUrl,
} from "../utils/utils";
import { useNavigate } from "react-router-dom";
import {
  failLocalMessage,
  newChatMessage,
  selectChat,
  setChatInput,
  successLocalMessage,
} from "../utils/actionUtils";
import NoApplicationsScreen from "../components/MyAppComponents/NoApplicationsScreen";
import MyApplicationRow from "../components/MyAppComponents/MyApplicationRow";
import { JobBg } from "../components/JobPanels/jobLayoutElements";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
    width: "100%",
    height: "100vh",
    position: "relative",
  },
  inner: {
    width: "100%",
    height: "100%",
    // backgroundColor: "red",
  },
  container: {
    // backgroundColor: "#fff",
    height: "100%",
    // minHeight: "calc(100vh)",
    width: "100%",
    overflow: "hidden",
    zIndex: 1,
    paddingTop: "32px",
  },
  headerPanel: {
    // borderRadius: Panels.borderRadius,
    // backgroundColor: Panels.backgroundColor,
    // boxShadow: Panels.boxShadow,
    padding: Panels.padding,
    ...FontStyle.headingBody,
    fontSize: "24px",
    textAlign: "center",
    // textAlign: "left",
    px: 2,
    width: "100%",
  },
};
const MyApplicationsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const loggedIn = isLoggedIn(auth);
  const myApps = useSelector((state) => state.apply.myApps);
  const [dataReady, setDataReady] = React.useState(false);
  useEffect(() => {
    if (!loggedIn) return;
    if (myApps.loaded) {
      setDataReady(true);
    } else {
      apiService.getAllApplicationData(
        dispatch,
        null,
        { ...auth.accountData },
        {}
      );
    }
  }, [loggedIn, myApps]);

  if (!dataReady) {
    return (
      <Stack direction="column" sx={styles.outer}>
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <Stack sx={styles.outer} direction="row">
      {myApps.appIds.length > 0 ? (
        <Stack
          sx={styles.container}
          spacing="8px"
          direction="column"
          alignItems="center"
          justifyContent="flex-start">
          <Box sx={styles.headerPanel}>My Applications</Box>
          <Stack
            spacing={{ xs: 1, lg: 2 }}
            direction="column"
            alignItems="center"
            sx={{
              width: "100%",
              px: 2,
            }}>
            {myApps.appIds.map((applicationId, index) => {
              return (
                <MyApplicationRow applicationId={applicationId} key={index} />
              );
            })}
          </Stack>
        </Stack>
      ) : (
        <NoApplicationsScreen />
      )}
      <JobBg />
    </Stack>
  );
};

export default MyApplicationsPage;
